const DEFAULT_PROPERTY = 'minWidth';

// Модификатор устанавливающий минимальную ширину popper такой же как ширина якоря
export const SAME_WIDTH = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  options: {
    property: DEFAULT_PROPERTY
  },
  fn: _ref => {
    let {
      state,
      options
    } = _ref;
    state.styles.popper[options.property || DEFAULT_PROPERTY] = "".concat(state.rects.reference.width, "px");
  },
  effect: _ref2 => {
    let {
      state,
      options
    } = _ref2;
    return () => {
      state.elements.popper.style[options.property || DEFAULT_PROPERTY] = "".concat(state.elements.reference.offsetWidth, "px");
    };
  }
};